// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Auth.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  CreateClientKeyRequest,
  CreateClientKeyResponse,
  DeleteClientKeyRequest,
  DeleteClientKeyResponse,
  GetAuthenticatedUserRequest,
  GetAuthenticatedUserResponse,
  SendAuthCodeRequest,
  SendAuthCodeResponse,
  ValidateAuthCodeRequest,
  ValidateAuthCodeResponse,
  ValidateClientKeyRequest,
  ValidateClientKeyResponse,
} from "./Models/AuthModels";

export const protobufPackage = "daisi.protos.v1";

export type AuthProtoDefinition = typeof AuthProtoDefinition;
export const AuthProtoDefinition = {
  name: "AuthProto",
  fullName: "daisi.protos.v1.AuthProto",
  methods: {
    /** Creates a client key given the proper secret key. */
    createClientKey: {
      name: "CreateClientKey",
      requestType: CreateClientKeyRequest,
      requestStream: false,
      responseType: CreateClientKeyResponse,
      responseStream: false,
      options: {},
    },
    validateClientKey: {
      name: "ValidateClientKey",
      requestType: ValidateClientKeyRequest,
      requestStream: false,
      responseType: ValidateClientKeyResponse,
      responseStream: false,
      options: {},
    },
    sendAuthCode: {
      name: "SendAuthCode",
      requestType: SendAuthCodeRequest,
      requestStream: false,
      responseType: SendAuthCodeResponse,
      responseStream: false,
      options: {},
    },
    validateAuthCode: {
      name: "ValidateAuthCode",
      requestType: ValidateAuthCodeRequest,
      requestStream: false,
      responseType: ValidateAuthCodeResponse,
      responseStream: false,
      options: {},
    },
    getAuthenticatedUser: {
      name: "GetAuthenticatedUser",
      requestType: GetAuthenticatedUserRequest,
      requestStream: false,
      responseType: GetAuthenticatedUserResponse,
      responseStream: false,
      options: {},
    },
    deleteClientKey: {
      name: "DeleteClientKey",
      requestType: DeleteClientKeyRequest,
      requestStream: false,
      responseType: DeleteClientKeyResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface AuthProtoServiceImplementation<CallContextExt = {}> {
  /** Creates a client key given the proper secret key. */
  createClientKey(
    request: CreateClientKeyRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateClientKeyResponse>>;
  validateClientKey(
    request: ValidateClientKeyRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ValidateClientKeyResponse>>;
  sendAuthCode(
    request: SendAuthCodeRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<SendAuthCodeResponse>>;
  validateAuthCode(
    request: ValidateAuthCodeRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ValidateAuthCodeResponse>>;
  getAuthenticatedUser(
    request: GetAuthenticatedUserRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetAuthenticatedUserResponse>>;
  deleteClientKey(
    request: DeleteClientKeyRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<DeleteClientKeyResponse>>;
}

export interface AuthProtoClient<CallOptionsExt = {}> {
  /** Creates a client key given the proper secret key. */
  createClientKey(
    request: DeepPartial<CreateClientKeyRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateClientKeyResponse>;
  validateClientKey(
    request: DeepPartial<ValidateClientKeyRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ValidateClientKeyResponse>;
  sendAuthCode(
    request: DeepPartial<SendAuthCodeRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<SendAuthCodeResponse>;
  validateAuthCode(
    request: DeepPartial<ValidateAuthCodeRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ValidateAuthCodeResponse>;
  getAuthenticatedUser(
    request: DeepPartial<GetAuthenticatedUserRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetAuthenticatedUserResponse>;
  deleteClientKey(
    request: DeepPartial<DeleteClientKeyRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<DeleteClientKeyResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
